<template>
	<a-card>
		<div class="title">
			<div class="leftBox" style="float: left;">
				<h3>服务机构</h3>
				<!--            <span><ExclamationCircleOutlined/>审核通过</span>-->
				<span v-if="this.form.examine == null">
					<ExclamationCircleOutlined />提交申请
				</span>
				<span :class="getClass(this.form.examine)" v-else>
					<ExclamationCircleOutlined />{{ COMMON_VARIABLE.approvalState[this.form.examine] }}
				</span>
			</div>
			<div style="float: right;">
				<div class="table-toolbar" v-if="this.form.examine!=1">
					<a-button type="primary" @click="onEdit">
						<template #icon>
							<form-outlined />
						</template>
					</a-button>
				</div>
			</div>
		</div>
		<div class="border-t">
			<a-form ref="ruleForm" :model="form" :rules="rules" class="inline-form mt-15">
				<!--可编辑区域 start-->
				<div class="hide">
					<a-form-item name="id">
						<a-input v-model:value="form.id" placeholder="请输入id" />
					</a-form-item>
					<a-form-item name="companyCode">
						<a-input v-model:value="form.companyCode" placeholder="请输入companyCode" />
					</a-form-item>
				</div>
				<table class="my-table">
					<tbody>
						<tr>
							<td colspan="12">
								<span class="label">机构名称：</span>
								<span>{{ form.name }}</span>
							</td>
							<td colspan="12">
								<span class="label">机构类型：</span>
								<span>
									<dict-render :dict-obj="dictObjs['servicetype']" :text="form.type" v-if="form.type"></dict-render>
								</span>
							</td>
						</tr>
						<tr>
							<td colspan="12">
								<span class="label">联系人：</span>
								<span>{{ form.contacts }}</span>
							</td>
							<td colspan="12">
								<span class="label">联系电话：</span>
								<span>{{ form.phone }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">工商注册地址：</span>
								<span>{{ form.logonAddress }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">办公地址：</span>
								<span>{{ form.workAddress }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">服务类型：</span>
								<span>{{ form.serviceTypeStr }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">服务范围：</span>
								<span>{{ form.scope }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">近三年主营业务：</span>
								<span>{{ form.mainBusiness }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">机构简介：</span>
								<span>{{ form.introduction }}</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">资料地址：</span>
								<span>
									<FileUpload v-model:value="form.means" :showBtn="false" :disabled="true" />
								</span>
							</td>
						</tr>
						<tr>
							<td colspan="24">
								<span class="label">logo：</span>
								<span>
									<ImgUpload v-model:value="form.logo" :showBtn="false" :disabled="true" />
								</span>
							</td>
						</tr>
					</tbody>
				</table>
				<!--可编辑区域 end-->
			</a-form>
		</div>
	</a-card>
	<UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="getForm" />
</template>

<script>
import { innovation, COMMON_VARIABLE } from "@/config/variableConfig"
// import DictRender from "@/components/other/DictSelect";
import { common_controller } from "@/api/commonService";
import { formMixin, dictMixin } from "@/mixins";
import { organizationApi } from "@/api/innovationService";
import FileUpload from "@/components/form/upload/FileUpload";
import ImgUpload from "@/components/form/upload/ImgUpload";
// import {message} from "ant-design-vue";
import UserModal from './components/UserModal';


export default {
	name: "index",
	components: { FileUpload, ImgUpload, UserModal },
	mixins: [formMixin, dictMixin],
	data() {
		return {
			dictNames: 'servicetype',
			innovation,
			COMMON_VARIABLE,
			options: [],
			form: {
				id: null,
				companyCode: this.$ls.get("companyCode") == null ? this.$ls.get("serviceOrganizationId") : this.$ls.get("companyCode"),
				name: null,
				type: null,
				contacts: null,
				phone: null,
				logonAddress: null,
				workAddress: null,
				serviceType: null,
				scope: null,
				mainBusiness: null,
				introduction: null,
				means: null,
				logo: null,
			},
		}
	},
	mounted() {
		this.getDict();
		this.getForm()
	},
	methods: {
		onEdit() {
			this.getAction({
				url: organizationApi.detail,
				params: {
					companyCode: this.$ls.get("companyCode") == null ? this.$ls.get("serviceOrganizationId") : this.$ls.get("companyCode")
				}
			}).then(res => {
				let obj = {
					...res,
					examine: '0',
				}
				this.onShowModal('userModal', obj);
			})
		},
		onShowModal(refName, data = {}) {
			const refEle = this.$refs[refName];
			refEle.form = Object.assign({}, data);
			refEle.visible = true;
		},
		getDict() {
			this.getAction({
				url: common_controller.getDictDataByGroupNumber,
				params: {
					groupNumbers: "servicetypefuwu"
				}
			}).then(res => {
				this.options = res
			})
		},
		getForm() {
			this.getAction({
				url: organizationApi.detail,
				params: {
					companyCode: this.$ls.get("companyCode") == null ? this.$ls.get("serviceOrganizationId") : this.$ls.get("companyCode")
				}
			}).then(res => {
				let str = '';
				let arr = res.serviceType.split(',');   //  [1,2,3]
				this.options.map(item => {
					arr.map(i => {
						if (item.dictValue == i) {
							str += item.dictLabel + ','
						}
					})
				})
				let obj = {
					...res,
					serviceTypeStr: str
				}
				this.form = obj
			})
		},
		getClass(status) {
			console.log(status, 'status')
			let className = '';
			switch (status) {
				case '0':
					className = 'fc-blue';
					break;
				case '1':
					className = 'fc-green';
					break;
				case '2':
					className = 'fc-red';
					break;
			}
			return className;
		}
	}
}
</script>
<style scoped lang="less">
.title {
	overflow: hidden;
	// display: flex;
	border-bottom: 4px solid #000000;

	.leftBox {
		display: flex;

		h3 {
			font-weight: bold;
		}

		span {
			font-size: 16px;
			margin-top: 4px;
			margin-left: 6px;
		}
	}
}

.hide {
	display: none !important;
}

.border-t {
	border-width: 1px;
	border-style: solid;
	border-color: #dedede;
	border-width: 0;
	border-top-width: 1px;

	.inline-form {
		.ant-form-item {
			display: flex
		}

		.ant-form-item-control-wrapper {
			flex: 1;
		}
	}

	.my-table {
		table-layout: fixed;

		td {
			border: 1px solid #dedede;
			padding: 15px;
		}

		.label {
			color: rgba(0, 0, 0, 0.85);
			font-size: 14px;
		}

		.ant-form-item {
			margin-bottom: 0;
		}
	}
}

.fc-blue {
	color: #409EFF;
}

.fc-green {
	color: #619c1b;
}

.fc-red {
	color: #ff3232;
}
</style>
